import React, { useState } from "react";


const TextField = ({
  value,
  min,
  disabled,
  label,
  placeholder,
  name,
  style,
  type,
  icon,
  iconPosition,
  onValueChange,
  onValueBlur,
  required = false,
  children,

}) => {
  const [error, setError] = useState("");

  const handleFocus = (e) => {
    e.target.classList.add("border-[#7ddbff]")
    
  };

  const handleBlur = (e) => {
    e.target.classList.remove("border-[#7ddbff]")
    const { name, value } = e.target;
    if (onValueBlur) {
      onValueBlur(name, value);
    }
    if (required && !value) {
      //setError("Field is required");
    } else {
      setError("");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // setValue(e.target.value);
    setError(""); // Clear any previous error
    if (onValueChange) {
      onValueChange && onValueChange(name, value);
    }
  };

  return (
    <div className=" relative mx-auto lg:min-w-[200px] w-full">
      {label && (
        <div className="py-1">
          <label className={`text-start font-roboto font-[400] text-[14px] ${disabled? "text-gray-400":""}`}>
            {label}
          </label>
        </div>
      )}
      <div className="relative flex items-center">
        {icon && <span className={`absolute ${iconPosition === "right" ? "right-3" : "left-3"}`}>{icon}</span>}

        {type !== "text-area" ? <input
          type={type}
          min={min}
          className={`border-2 truncate w-full p-2 ${icon ? iconPosition === "right" ? "pr-10" : "pl-10 " : ""} 
          rounded-md outline-none border-2 !bg-[#7ddbff] !bg-opacity-[30%] text-sm ${value ? "bg-gray-200" : ""}`}
          placeholder={placeholder}
          name={name}
          disabled={disabled}
          value={value}
          style={{  ...style }}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}
          required={required}
        />
          : <textarea className={` w-full p-2 ${icon ? iconPosition === "right" ? "pr-10" : "pl-10 " : ""} 
        rounded-md outline-none border-2 !bg-[#7ddbff] !bg-opacity-[30%] text-sm ${value ? "bg-gray-200" : ""}`}
            name={name}

            placeholder={placeholder}
            disabled={disabled}
            value={value}
            required={required}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            style={{ maxHeight: "15vh",  ...style }} />}
      </div>


      {error && (
        <div className="text-red-500 text-xs mt-1  text-start px-2">
          {error}
        </div>
      )}
    </div>
  );
};

export default TextField;
